import { Outlet, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CandidatoRoute } from '@/components/CandidatoRoute';
import { supabase } from '@/integrations/supabase/client';

export default function CandidatoShell() {
  const navigate = useNavigate();

  const handleSair = async () => {
    await supabase.auth.signOut();
    navigate('/auth', { replace: true });
  };

  return (
    <CandidatoRoute>
      <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/10">
        <header className="border-b bg-background/80 backdrop-blur">
          <div className="max-w-2xl mx-auto flex items-center justify-between px-4 py-3">
            <div className="flex items-center gap-2">
              <div className="h-9 w-9 rounded-lg bg-primary text-primary-foreground flex items-center justify-center font-bold">
                GA
              </div>
              <div className="leading-tight">
                <p className="font-semibold text-sm">Grupo Ares</p>
                <p className="text-xs text-muted-foreground">Sua contratação</p>
              </div>
            </div>
            <Button variant="ghost" size="sm" onClick={handleSair} aria-label="Sair">
              <LogOut className="h-4 w-4 mr-1" />
              Sair
            </Button>
          </div>
        </header>

        <main className="max-w-2xl mx-auto px-4 py-6 sm:py-10">
          <Outlet />
        </main>

        <footer className="text-center text-xs text-muted-foreground py-6">
          Precisa de ajuda? Fale com o RH.
        </footer>
      </div>
    </CandidatoRoute>
  );
}
